import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import AllInputs from '../../../../inputs/AllInputs';
import _ from 'lodash';

const EditAll = (props) => {
  const departments = useSelector((state) => state.settings_departments.dealership_departments);
  const active_vehicle = useSelector((state) => state.settings_refresh.active_vehicle);

  const showDepartments = () => Object.values(departments).filter(
    (dept) => dept.department_type !== 'data step'
  );

  const vehicleColumns = (department) => {
    if (_.isEmpty(department) || !department.department_properties) {
      return [];
    }
    return _.sortBy(Object.values(department.department_properties), 'order');
  };

  const getDepartmentBody = (department, vehicle) => vehicleColumns(department).map((vehCol) => {
    if (vehCol.vehicle_column.name === 'thumbnail') {
      return null;
    }
    const colObject = _.find(vehicle.vehicle_properties, { key: vehCol.vehicle_column.name }) || {};
    const setdisabled = false;
    const options = useMemo(() => Array.isArray(vehCol.vehicle_column.options)
      ? vehCol.vehicle_column.options.map((opt) => ({
          id: opt.id || _.uniqueId('option_'),
          name: opt.name,
          label: opt.name,
        }))
      : [], [vehCol.vehicle_column.options]);

    return (
      <div
        className="col-md-3 text-center pad-top-1 pad-bottom-1"
        key={`vcedit_${_.uniqueId('vcedit_')}_${vehCol.vehicle_column.id}_${department.id}`}
      >
        <label className="control-label">
          {vehCol.vehicle_column.display_name || vehCol.vehicle_column.name}
        </label>
        <AllInputs
          value={colObject.value || ''}
          type={vehCol.vehicle_column.input_name || 'text'}
          name={vehCol.vehicle_column.name}
          parentid={vehicle.id}
          updatetype="vehicleproperty"
          setdisabled={setdisabled}
          user_name={colObject.user_name || ''}
          updated_at={colObject.updated_at}
          options={options}
          vehicle={vehicle}
          className={
            vehCol.vehicle_column.input_name?.toLowerCase() === 'select'
              ? 'form-select'
              : 'form-control'
          }
        />
      </div>
    );
  }).filter(Boolean);

  const getBody = () => {
    const vehicle = active_vehicle;
    if (!vehicle || !departments) {
      return null;
    }
    return departments.map((department) => (
      <div className="card" key={`editcard_${department.id}`}>
        <div className="card-header bg-info text-white">
          <div className="text-capitalize">
            {department.display_name || department.name}
          </div>
        </div>
        <div className="card-text">
          <div className="row text-capitalize">
            {getDepartmentBody(department, vehicle)}
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className="container bg-light pad-top-1">
      <div className="card space-top-2">{getBody()}</div>
    </div>
  );
};

export default EditAll;